import { FlowCellsBand } from "@/components/home/FlowCellsBand";
import { Toaster } from "sonner";
import { useEffect } from "react";
import { useLenis } from "@/hooks/useLenis";
import { useSeo, JsonLd, siteJsonLd } from "@/lib/seo";
import { BootSequence } from "@/components/landing/BootSequence";
import { RiskGate } from "@/components/landing/RiskGate";
import { CookieConsent } from "@/components/landing/CookieConsent";
import { ScrollProgress } from "@/components/landing/ScrollProgress";
import { TopTicker } from "@/components/landing/TopTicker";
import { Nav } from "@/components/landing/Nav";
import { HeroTerminal } from "@/components/home/HeroTerminal";
import { FreeToolsHero } from "@/components/home/FreeToolsHero";
import { EdgeIn3 } from "@/components/home/EdgeIn3";
import { Engine } from "@/components/home/Engine";
import { ModuleRows } from "@/components/home/ModuleRows";
import { GetVsNever } from "@/components/home/GetVsNever";
import { VerifiedRecord, Access, ReferralTeaser } from "@/components/home/Sections";
import { FAQ } from "@/components/landing/FAQ";
import { CTABand } from "@/components/landing/CTABand";
import { Footer } from "@/components/landing/Footer";
import { FounderBar } from "@/components/landing/FounderBar";

export default function Landing() {
  useLenis();
  useSeo({
    title: "TradrQuant — Real-Time Crypto Order Flow & Trading Terminal | Hyperliquid, Binance, OKX",
    description:
      "Low-latency crypto trading terminal for retail traders. Real-time order flow, footprint, CVD, liquidations, funding, open interest and Hyperliquid whale wallets from Binance, OKX, Bybit and Coinbase. Free BTC & ETH terminal, verified performance.",
    path: "/",
  });
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.slice(1);
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 700);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="relative bg-[#08090B] text-white min-h-screen overflow-x-hidden">
      <JsonLd data={siteJsonLd()} />
      <BootSequence />
      <ScrollProgress />
      <TopTicker />
      <Nav />
      <main>
        <HeroTerminal />
        <FreeToolsHero />
        <FlowCellsBand />
        <EdgeIn3 />
        <Engine />
        <ModuleRows />
        <GetVsNever />
        <VerifiedRecord />
        <Access />
        <ReferralTeaser />
        <FAQ />
        <CTABand />
      </main>
      <Footer />
      <RiskGate />
      <CookieConsent />
      <FounderBar />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid rgba(186,205,28,0.3)",
            color: "#fff",
            borderRadius: "0",
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: "13px",
          },
        }}
      />
    </div>
  );
}
